var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#CDD4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.016 15.2632C8.248 15.2632 6.816 16.7705 6.816 18.6316C6.816 20.4926 8.248 22 10.016 22C11.784 22 13.216 20.4926 13.216 18.6316C13.216 16.7705 11.784 15.2632 10.016 15.2632ZM14.8 15.2632V22H21.2V15.2632H14.8ZM10 6L6 13.5789H14L10 6ZM19.8 6.42105C18.952 6.42105 18.352 6.89263 18 7.40632C17.648 6.89263 17.048 6.42105 16.2 6.42105C14.952 6.42105 14 7.49895 14 8.73684C14 10.4211 15.936 11.6168 18 13.5789C20.064 11.6168 22 10.4211 22 8.73684C22 7.49895 21.048 6.42105 19.8 6.42105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationModelIcon);
export default __webpack_public_path__ + "static/media/EvaluationModelIcon.9a9616d46d805f4dbe60a9590ca53435.svg";
export { ForwardRef as ReactComponent };